import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';

interface Type {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-listing-details',
  templateUrl: './listing-details.component.html',
  styleUrls: ['./listing-details.component.css']
})

export class ListingDetailsComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  ListPrice: any;
  OnMarketDate: Date;
  ConcessionsAmount: any = '';
  ConcessionsComments: string = '';
  BuyerAgencyCompensation: any = '';
  BuyerAgencyCompensationType: string = 'percent';
  todayDate: Date = new Date();
  submitted: boolean = false;

  listingData: {};
  isLoader = false;
  myListingId: string;
  historyState: any;

  compensationType: Type[] = [
    { value: 'percent', viewValue: 'Percent of Sale Price' },
    { value: 'dollars', viewValue: 'Dollars' }
  ];

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService
  ) { };

  myForm: FormGroup = new FormGroup({
    ListPrice: new FormControl('', [Validators.required]),
    OnMarketDate: new FormControl('', [Validators.required, Validators.minLength(0)]),
    ConcessionsAmount: new FormControl(''),
    BuyerAgencyCompensation: new FormControl(''),
    ConcessionsComments: new FormControl(''),
    BuyerAgencyCompensationType: new FormControl('percent'),
  });

  ngOnInit(): void {
    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;
    if (this.historyState.listingData) {
      this.myForm.setValue({
        ListPrice: this.historyState.listingData.ListPrice,
        OnMarketDate: this.historyState.listingData.OnMarketDate,
        ConcessionsAmount: this.historyState.listingData.ConcessionsAmount ? this.historyState.listingData.ConcessionsAmount : null,
        BuyerAgencyCompensation: this.historyState.listingData.BuyerAgencyCompensation ? this.historyState.listingData.BuyerAgencyCompensation : null,
        ConcessionsComments: this.historyState.listingData.ConcessionsComments ? this.historyState.listingData.ConcessionsComments : null,
        BuyerAgencyCompensationType: this.historyState.listingData.BuyerAgencyCompensationType ? this.historyState.listingData.BuyerAgencyCompensationType : null
      })
    } else if (this.historyState) {
      this.myForm.setValue({
        // ListPrice: this.historyState.ListPrice,
        // OnMarketDate: this.historyState.listingDetails ? this.historyState.listingDetails.ListingContractDate : null,
        // ListPrice: null,
        // OnMarketDate: null,
        ListPrice: this.historyState.ListPrice,
        // OnMarketDate: this.historyState.OnMarketDate,
        ConcessionsAmount: this.historyState.listingDetails && this.historyState.listingDetails.ConcessionsAmount && this.historyState.listingDetails.ConcessionsAmount != '' ? typeof (this.historyState.listingDetails.ConcessionsAmount) == 'string' ? parseInt(this.historyState.listingDetails.ConcessionsAmount) : this.historyState.listingDetails.ConcessionsAmount : null,
        BuyerAgencyCompensation: 2.5,
        ConcessionsComments: this.historyState.listingDetails && this.historyState.listingDetails.ConcessionsComments ? this.historyState.listingDetails.ConcessionsComments : "",
        BuyerAgencyCompensationType: 'percent'
      })
    }
    else {
      console.log('no data in history state');
    }

    this.myForm.get("BuyerAgencyCompensationType").valueChanges.subscribe(x => {
      if (x == 'percent') {
        this.myForm.controls['BuyerAgencyCompensation'].setValue(2.5);
      } else if (x == 'dollars') {
        this.myForm.controls['BuyerAgencyCompensation'].setValue(2500);
      }
    });

    this.myForm.get("ListPrice").valueChanges.subscribe(x => {
      this.historyState.ListPrice = x;
      let minSavings = Math.round(x * 0.03 - 590);
      this.historyState.minSavings = minSavings < 0 ? 0 : minSavings;
      let maxSavings = Math.round(x * 0.05 - 590);
      this.historyState.maxSavings = maxSavings < 0 ? 0 : maxSavings;
    });

    this.myForm.get("OnMarketDate").valueChanges.subscribe(x => {
      this.historyState.OnMarketDate = x;
    });
  }

  back() {
    this.router.navigateByUrl('/exterior', {
      state: this.historyState
    });
  }

  saveListingDetails(submit) {
    this.submitted = true;

    if (this.myForm.status == 'VALID' || (this.myForm.value.ListPrice && this.myForm.value.OnMarketDate)) { // || (submit == 'skip')
      this.listingData = {
        ListPrice: this.myForm.value.ListPrice,
        OnMarketDate: new Date(this.myForm.value.OnMarketDate), //this.convertDate(this.myForm.value.OnMarketDate)
        ConcessionsAmount: this.myForm.value.ConcessionsAmount,
        BuyerAgencyCompensation: this.myForm.value.BuyerAgencyCompensation,
        ConcessionsComments: this.myForm.value.ConcessionsComments,
        BuyerAgencyCompensationType: this.myForm.value.BuyerAgencyCompensationType ? this.myForm.value.BuyerAgencyCompensationType : ''
      }
      this.updateMyListings(submit);
    } else {
      this.toastService.toast('Madatory fields are not filled', ToastType.Warning);
    }
  }

  updateMyListings(submit) {
    if (submit == null || submit == 'skip') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.6) {
        this.listingData["stage"] = 1.6;
      }
      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Listing Details') <= -1) {
          this.listingData["stageName"] = "Listing Details" + "," + this.historyState.stageName;
        }
      } else {
        this.listingData["stageName"] = "Listing Details" + "," + "Home Details";
      }
    }
    this.listingData["updatedDate"] = new Date();
    this.listingData = this.filterInputJson(this.listingData);
    this.myListingsService.UpdateListing(this.myListingId, this.listingData).subscribe(
      {
        next: (res) => {
          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.6) {
            this.historyState['completedIndex'] = 1.6;
          }
          this.historyState['listingData'] = this.listingData;
          this.historyState.stageName = this.listingData["stageName"];

          this.isLoader = false;

           if (submit == 'skip') {
            this.historyState['completedIndex'] = 1.6;
            this.router.navigateByUrl('/plans', {
              state: this.historyState
            });
          } else {
            this.router.navigateByUrl('/photos', {
              state: this.historyState
            });
          }
        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          this.isLoader = false;
          console.log(err);
        }
      }
    );
  }

  skip() {
    this.historyState['completedIndex'] = 1.6;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }

  convertDate(OnMarketDate: Date) {
    var date = new Date(OnMarketDate),
      mnth = ("" + (date.getMonth() + 1)).slice(-2),
      day = ("" + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join("/");
  }

}
